import { Component, OnInit, Input } from '@angular/core';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';

@Component({
  selector: 'app-info-tile',
  templateUrl: './info-tile.component.html'
})
export class InfoTileComponent implements OnInit {
  _primaryValue = 0;
  _secondaryValue = 0;
  @Input() labelToolTip;

  @Input() set primaryValue(val:number) {
    if (val != undefined) {
      this._primaryValue = val;
    }
  }

  @Input() secondaryType: string;

  @Input() set secondaryValue(val:number) {
    if (val != undefined) {
      this._secondaryValue = val;
    }
  }

  @Input() label: string;

  constructor(public themeService: ThemeManagerService) { }

  ngOnInit() {
  }

  getAbsolutePercentageLabel(value:number):string {
    return this.getPercentageLabel(Math.abs(value));
  }

  getPercentageLabel(value:number):string {
    return `${Math.trunc(value)}%`;
  }
}
